import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { ISproutActionProps } from "./SproutAction.props";

const styles = {
  primary:
    "border-primary-700 bg-primary text-primary-foreground hover:border-navy-ink hover:bg-primary-700",
  secondary: "border-navy-ink bg-sunflower text-navy-ink hover:bg-whiteboard",
  ghost:
    "border-transparent bg-transparent text-primary underline decoration-2 underline-offset-4 hover:underline-offset-8",
  destructive:
    "border-oxidized-orange bg-oxidized-orange text-primary-foreground hover:border-charcoal-green-ink hover:bg-charcoal-green-ink",
} as const;

export const SproutAction = ({ action, className }: ISproutActionProps) => {
  const Link = getComponent("Link");
  return (
    <Link
      aria-label={action.accessibilityLabel || undefined}
      className={cn(
        "inline-flex min-h-12 items-center justify-center rounded-[14px] border-2 px-5 py-3 font-sprout-mono text-sm font-extrabold leading-[1.4] shadow-[0_3px_0_#14213d,0_12px_18px_-14px_rgba(20,33,61,0.55)] transition-[background-color,border-color,color,text-underline-offset,transform,box-shadow] duration-200 ease-out active:translate-y-[2px] active:shadow-[0_1px_0_#14213d] focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-ring",
        styles[action.style || "primary"],
        className,
      )}
      href={action.href}
      rel={action.openInNewTab ? "noopener noreferrer" : undefined}
      target={action.openInNewTab ? "_blank" : undefined}
    >
      {action.label}
    </Link>
  );
};

SproutAction.displayName = "Content::SproutAction";
